import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RobotIcon = ({
  title = 'RobotIcon',
  viewBox = '0 0 115 115',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path
      d="M57.63 114.465c31.529 0 57.089-25.56 57.089-57.09 0-31.53-25.56-57.09-57.09-57.09C26.1.285.54 25.845.54 57.375c0 31.53 25.56 57.09 57.09 57.09z"
      fill="#none"
    />
    <mask id="a" maskUnits="userSpaceOnUse" x="0" y="0">
      <path
        d="M57.63 114.465c31.529 0 57.089-25.56 57.089-57.09 0-31.53-25.56-57.09-57.09-57.09C26.1.285.54 25.845.54 57.375c0 31.53 25.56 57.09 57.09 57.09z"
        fill="#F6F5F0"
      />
    </mask>
    <g mask="url(#a)">
      <path
        d="M70.729 20.215h-26.08c-6.627 0-12 5.373-12 12v26.08c0 6.628 5.373 12 12 12h26.08c6.627 0 12-5.372 12-12v-26.08c0-6.627-5.373-12-12-12zM91.76 114.485H23.37l.17-34.4a4.45 4.45 0 014.43-4.43h59.48a4.44 4.44 0 014.43 4.43l-.12 34.4z"
        fill="#BCBEC0"
      />
      <path d="M47.6 44.995a6.4 6.4 0 10-.001-12.8 6.4 6.4 0 000 12.8z" fill="#414042" />
      <path
        d="M47.6 46.995a8.4 8.4 0 11-.001-16.8 8.4 8.4 0 010 16.8zm0-14.79a6.4 6.4 0 100 12.8 6.4 6.4 0 000-12.8z"
        fill="#939598"
      />
      <path d="M57.69 97.005a3.6 3.6 0 10-.001-7.2 3.6 3.6 0 000 7.2z" fill="#414042" />
      <path
        d="M57.69 99.015a5.61 5.61 0 115.6-5.61 5.62 5.62 0 01-5.6 5.61zm0-9.21a3.61 3.61 0 10-.021 7.22 3.61 3.61 0 00.02-7.22z"
        fill="#939598"
      />
      <path d="M74.04 97.005a3.6 3.6 0 10-.001-7.2 3.6 3.6 0 000 7.2z" fill="#414042" />
      <path
        d="M74.04 99.015a5.61 5.61 0 115.6-5.61 5.62 5.62 0 01-5.6 5.61zm0-9.21a3.61 3.61 0 10-.021 7.22 3.61 3.61 0 00.02-7.22z"
        fill="#939598"
      />
      <path d="M41.34 97.005a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z" fill="#414042" />
      <path
        d="M41.34 99.015a5.61 5.61 0 115.6-5.61 5.62 5.62 0 01-5.6 5.61zm0-9.21a3.61 3.61 0 10-.021 7.22 3.61 3.61 0 00.02-7.22z"
        fill="#939598"
      />
      <path d="M67.77 44.995a6.4 6.4 0 100-12.8 6.4 6.4 0 000 12.8z" fill="#414042" />
      <path
        d="M67.77 46.995a8.4 8.4 0 118.4-8.4 8.41 8.41 0 01-8.4 8.4zm0-14.79a6.4 6.4 0 10-.001 12.8 6.4 6.4 0 000-12.8zM57.69 26.115c-5.7 0-8.52-5.9-8.52-5.9h17s-2.78 5.9-8.48 5.9zM67.84 55.135h-20.3a3.24 3.24 0 100 6.48h20.3a3.24 3.24 0 000-6.48z"
        fill="#939598"
      />
      <path
        d="M32.64 37.855h-3.55v14.53h3.55v-14.53zM86.28 37.855h-3.55v14.53h3.55v-14.53zM23.49 81.535h-8.42v32.95h8.42v-32.95zM100.179 81.535h-8.42v32.95h8.42v-32.95zM69.41 70.295H45.96v5.36h23.45v-5.36zM67.84 53.135h-20.3a5.24 5.24 0 100 10.48h20.3a5.24 5.24 0 000-10.48zm-11.81 2h3.31v6.48h-3.31v-6.48zm-2.56 6.48h-3.31v-6.48h3.31v6.48zm8.43-6.48h3.32v6.48H61.9v-6.48zm-17.6 3.24a3.24 3.24 0 013.24-3.24h.06v6.48h-.06a3.25 3.25 0 01-3.24-3.24zm23.54 3.24h-.07v-6.48h.07a3.24 3.24 0 010 6.48z"
        fill="#414042"
      />
    </g>
  </CreateIconComponent>
);

export default RobotIcon;
